<template>

  <div class="page-container">

    <router-view></router-view> <!-- Renders nested routes -->

    <hr class="divider">

    <div class="section">
      <p>If you have a question that isn’t covered here, submit a <router-link to="/user-support" class="support__request_button">Support Request &rangle; </router-link></p>
    </div>

    <div class="sub-links">
      <router-link to="/construction-code-ai-assistant/help">Help Center</router-link>
      |
      <router-link to="/construction-code-ai-assistant/terms">Terms of Use</router-link>
      |
      <router-link to="/construction-code-ai-assistant/privacy">Privacy Policy</router-link>
    </div>


  </div>

</template>

<script>

export default {
  name: "CodeAuthority",
};
</script>

<style scoped>
.support__request_button{
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}
</style>